module.exports = __webpack_public_path__ + "static/img/logo.b0fab53b.png";